



























































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import { Prop } from 'vue-property-decorator'

export interface WidgetPhoneList {
  department?: string
  name?: string
  phone: string
}

@Component({
  components: { BaseInput }
})
export default class WidgetPhone extends Vue {
  @Prop({ default: false }) dark!: boolean
  search: string = ''
  phoneListArray: WidgetPhoneList[] = this.widgetPhoneList.sort((a, b) => {
    {
      const nameA = a.department
      const nameB = b.department
      if (nameA < nameB) {
        return -1
      }
      if (nameA > nameB) {
        return 1
      }
      return 0
    }
  })

  get widgetPhoneList(): WidgetPhoneList[] {
    let list = localStorage.getItem('niknevis_phone_list')
    if (!list) {
      localStorage.setItem('niknevis_phone_list', JSON.stringify(widgetPhoneList()))
      list = localStorage.getItem('niknevis_phone_list')
    }
    return JSON.parse(list)
  }

  get phoneList() {
    this.changeVal()
    return (this.search === '')
      ? this.phoneListArray
      : this.phoneListArray.filter((item) => {
          return (item?.name?.includes(this.search) || item.phone.includes(this.search) || item?.department?.includes(this.search))
        }
      )
  }

  changeVal() {
    if (this.search.includes('=')) {
      let name = this.search.split('=')[0]
      this.phoneListArray.filter((item) => {
        return item?.name?.includes(name)
      })[0].phone = this.search.split('=')[1]
      localStorage.setItem('niknevis_phone_list', JSON.stringify(this.phoneListArray))
    }
  }

}

//WidgetPhoneList
function widgetPhoneList(): WidgetPhoneList[] {
  return [
    {
      department: 'پشتیبانی',
      name: 'رویا طباطبایی',
      phone: '11'
    },
    {
      department: 'رسانه',
      name: 'شیرین قربانی',
      phone: '12'
    },
    {
      department: 'پشتیبانی',
      name: 'سپیده موسوی',
      phone: '13'
    },
    {
      department: 'پشتیبانی',
      name: 'مریم ریاضت بخش',
      phone: '14'
    },
    {
      department: 'مالی',
      name: 'علیرضا اکبری',
      phone: '15'
    },
    {
      department: 'تولید محتوا',
      name: 'بخش تولید محتوا',
      phone: '16'
    },
    {
      department: 'مدیر بخش مارکتینگ و سئو',
      name: 'امیر برمچ',
      phone: '17'
    },
    {
      department: 'مدیر بخش پشتیبانی و محتوا',
      name: 'جواد یوسفپور',
      phone: '18'
    },
    {
      department: 'مدیر بخش فنی',
      name: 'مهدی ابراهیمی',
      phone: '20'
    }
  ]
}

